import React, { Component, Fragment } from 'react'
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom'
import {hideShiJieSchoolNames} from './constants/constants'
import Index from './pages/index'
import Major from './pages/Major'
import School from './pages/School'
import Profession from './pages/Profession'
import MajorWishList from './pages/MajorWishList'
import MajorWishListNew from './pages/MajorWishListNew'
import SchoolWishListNew from './pages/SchoolWishListNew'
import SchoolWishList from './pages/SchoolWishList'
import SubjectChoice from './pages/SubjectChoice'
import Status404 from './pages/Status404'
import logo from './assets/svg/logo2.png'
import homeIcon from './assets/svg/icon_Home.png';
import backIcon from './assets/ic_fanhui.png';
import HomePage from './pages/SelectSubject'
import SelectSubject from './pages/SelectSubject/SelectSubject'
import SelectSubjectResult from './pages/SelectSubject/SelectSubjectResult'
import AnalyzeDetail from './pages/xkCoach/wishListAnalyze/detail'
import UnAttention from './pages/SelectSubject/Attention'

import { xauthApi } from './constants/constants'
import axios from 'utils/new_request'
import './styles/icomoon/style.css'
import './App.less'
import 'static/css/public.less'
import Home from './pages/index'


const studentSite = process.env.BUILD_TEST
  ? 'xs.t.shijieu.cn'
  : 'xs.shijieu.cn'
const parentSite = process.env.BUILD_TEST
  ? 'jz.t.shijieu.cn/parents'
  : 'jz.shijieu.cn/parents'


class App extends Component {
  user_detail=JSON.parse(localStorage.getItem('user_detail'));
  state = {

  }

  componentDidMount() {
    const { invoker } = this.props;
    const inParentMode = invoker === 'parents';

    // console.log("Xauth",xauthApi)
    let showPatternType=inParentMode?
        (this.user_detail&&this.user_detail.parents&&this.user_detail.parents.school&&this.user_detail.parents.school.showPattern&&this.user_detail.parents.school.showPattern.type)
        :
        (this.user_detail&&this.user_detail.student&&this.user_detail.student.school&&this.user_detail.student.school.showPattern&&this.user_detail.student.school.showPattern.type);
    if (showPatternType === 4) { document.title = inParentMode ? '学生发展云平台家长端' : '学生发展云平台学生端' }
    
  }

  render() {
    const { invoker } = this.props;
    const inParentMode = invoker === 'parents';
    let isZiGuang=this.user_detail&&hideShiJieSchoolNames.includes(this.user_detail.outerName);
    let showPattern=inParentMode?
        (this.user_detail&&this.user_detail.parents&&this.user_detail.parents.school&&this.user_detail.parents.school.showPattern)
        :
        (this.user_detail&&this.user_detail.student&&this.user_detail.student.school&&this.user_detail.student.school.showPattern);
    const homePage = window.location.pathname=='/xstatic/xbag/college'?`//${parentSite}`:inParentMode
    ? `//${parentSite}`
    : `//${studentSite}`
    const isXkCoach=window.location.pathname.includes('xkcoach');
    const isXkCoachSchoolWishList=window.location.pathname.includes('xkcoach/schoolwishlist');
    const isXkCoachMajorWishList=window.location.pathname.includes('xkcoach/majorwishlist');
      return <BrowserRouter basename="/">
        <Fragment>
          <header>
            <span>选科查询</span>
            <div className="img-container">
                  {!isZiGuang&&<img src={showPattern?showPattern.type===1?logo:showPattern.basicLogo:logo}/>}
                  {showPattern&&showPattern.type===2&& <img className='logo-group-right' src={logo} alt=""/>}
                </div>
          </header>
        <main className={`${(isXkCoachSchoolWishList||isXkCoachMajorWishList)?'height-all':''}`}>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route path="/major" component={Major} />
            <Route path="/school" component={School} />
            <Route path="/profession" component={Profession} />
            <Route path="/majorwishlist" component={MajorWishList} />
            <Route path="/xkcoach/majorwishlist" component={MajorWishListNew} />
            <Route path="/xkcoach/schoolwishlist" component={SchoolWishListNew} />
            <Route path="/schoolwishlist" component={SchoolWishList} />
              <Route path="/subjectchoice" component={SubjectChoice} />
              <Route path="/analyzedetail" component={AnalyzeDetail} />
              <Route path="/selectsubject" component={SelectSubject} />
              <Route path="/selectsubjectResult" component={SelectSubjectResult} />
              <Route path="/attention" component={UnAttention} />
            <Route component={Status404}></Route>
          </Switch>
        </main>
      </Fragment>
    </BrowserRouter>
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js